<template>
  <v-container fluid>
    <page-header>
      <template v-slot:title>
        <div>
          Minha conta 💻
        </div>
      </template>
    </page-header>
    <user-data></user-data>
    <!-- <v-tabs v-model="tabs" grow background-color="primary center-active dark">
      <v-tab><v-icon left>mdi-account-details</v-icon> Informações</v-tab>
      <v-tab disabled><v-icon left>mdi-cog</v-icon> Configurações</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <user-data></user-data>
      </v-tab-item>
      <v-tab-item> -->
        <!-- <user-settings ></user-settings> -->
      <!-- </v-tab-item>
      </v-tabs-items>
    <v-card v-if="false" style="border-radius:12px">
      <v-card-title primary-title>
        <div class="headline mb-0">Titulo</div>
      </v-card-title>
      <v-card-text>
        <div>meus dados</div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn flat text color="error">Cancelar</v-btn>
        <v-btn flat text color="primary">OK</v-btn>
      </v-card-actions>
    </v-card> -->
  </v-container>
</template>

<script>
import UserData from '../components/user_profile/UserData.vue';
export default {
  components: { UserData },
  name: "Account",
  data() {
    return {
      tabs: null,
    }
  },
};
</script>